import { HashLoader } from 'react-spinners';
import { IHashLoading } from './types';

const HashLoading: React.FC<IHashLoading> = ({
  size = 30,
  speedMultiplier = 1,
  color = '#226A43',
}) => (
  <HashLoader
    color={color}
    loading
    size={size}
    speedMultiplier={speedMultiplier}
  />
);

export default HashLoading;
